import React from "react";
import "../styles/airtel.css";
function AircelVerification() {
  return (
    <div className="container">
      <h2>Aircel Verification</h2>

      <img src="/images/image nitish/Matrix/Aircel/Home1.png" alt="Home1" />

      <img src="/images/image nitish/Matrix/Aircel/Home.png" alt="Home" />
      <img src="/images/Aircel/Home2.png" alt="Home2" />

      <img src="/images/image nitish/Matrix/Aircel/Screen.png" alt="Screen" />
      <img src="/images/Aircel/Screen1.png" alt="Screen1" />

      <img src="/images/image nitish/Matrix/Aircel/Reports.png" alt="Reports" />
      <img src="/images/image nitish/Matrix/Aircel/Reports1.png" alt="Reports1" />
      <img src="/images/image nitish/Matrix/Aircel/Reports2.png" alt="Reports2" />
    </div>
  );
}

export default AircelVerification;